import layoutsComponents from "../../secrets-web/src/layouts/components"

export default layoutsComponents